/**
 * MÜŞTERİ BİLGİLENDİRME ROZETİ
 *
 * ── NİÇİN VAR ──────────────────────────────────────────────────────────────
 * Üretim aşaması ilerledikçe müşteriye otomatik mail gidiyor
 * (`functions/src/klaviyo/productionStageTrigger.ts`). Atölye bunu göremezse
 * telefon eden müşteriye "sizin ürün daha kesilmedi" diyebilir — oysa müşteri
 * o sabah "ahşabınız kesildi" maili almıştır. Çelişkili iki bilgi, sistemin
 * güvenilirliğini tek seferde bitirir.
 *
 * Rozet üretim kaydındaki `notifiedStages` haritasını okur; o haritayı yalnızca
 * mail FİİLEN gittiğinde tetikleyici yazar. Yani "gitti" demek her zaman
 * doğrudur — ayar kapalı olduğu ya da adres bulunmadığı için atlanan aşama
 * haritaya hiç girmez.
 */

/** Aşama kimliği → müşteriye anlatılan kısa ad. Ayarlardaki mesaj adı değil. */
const STAGE_SHORT: Record<string, string> = {
  "prod-cnc": "Kesim",
  "prod-prod": "Zımpara/Yağlama",
  "prod-packaged": "Paketleme",
};

export function NotifiedBadge({
  notifiedStages,
}: {
  notifiedStages?: Record<string, unknown> | null;
}) {
  const stages = Object.keys(notifiedStages ?? {});
  // Hiç mail gitmemişse rozet BASILMAZ. Her satırın altında duran "0 bildirim"
  // notu gürültüdür ve gerçek bilgiyi görünmez kılar.
  if (stages.length === 0) return null;

  // Sözlükte olmayan aşama ham kimliğiyle gösterilir: sessizce yutmak, mailin
  // gittiğini gizlerdi.
  const names = stages.map((s) => STAGE_SHORT[s] ?? s);

  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full border border-sky-300 bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-800"
      title={`Müşteriye mail gitti: ${names.join(", ")}`}
    >
      <svg viewBox="0 0 20 20" aria-hidden="true" className="h-3 w-3" fill="currentColor">
        <path d="M2.5 5.5A1.5 1.5 0 0 1 4 4h12a1.5 1.5 0 0 1 1.5 1.5v.3L10 10.6 2.5 5.8v-.3Z" />
        <path d="M2.5 7.6V14.5A1.5 1.5 0 0 0 4 16h12a1.5 1.5 0 0 0 1.5-1.5V7.6L10 12.4 2.5 7.6Z" />
      </svg>
      Müşteri bilgilendirildi ({names.length})
    </span>
  );
}

export default NotifiedBadge;
